import { SectionTemplateHeader } from "components/MainSectionTemplate/SectionTemplateHeader";
import { CustomSection } from "components/MainSectionTemplate/types";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import Table from "components/Tables/Table";
import React from "react";
import { getLinkedInvoiceColumns } from "show/components/linkeddocumentpanel/LinkedInvoicePanel";

interface Props {
  invoices: server.dto.InvoiceForList[]
}

const UnassignedInvoicesPanel = (props: Props) => {
  const anyV2 = props.invoices.some(x => x.isV2);
  return <SectionPanel.Panel
    header={<SectionTemplateHeader>Unassigned invoices</SectionTemplateHeader>}
  >
    <Table
      items={props.invoices}
      isLoading={false}
      getKey={invoice => invoice.invoiceId.toString()}
      columns={getLinkedInvoiceColumns(anyV2)}
      hideHeader
    />
  </SectionPanel.Panel>
}

export const unassignedInvoicesPanelSection = (invoices: server.dto.InvoiceForList[]): CustomSection => {
  return {
    key: "unassignedInvoices",
    type: "custom",
    render: () => <UnassignedInvoicesPanel key="unAssignedInvoices" invoices={invoices} />
  }
}